import * as React from 'react';

import { ConfirmationDialogSettings } from './components/ConfirmationDialog/component';

export const useDialogsProvider = () => {
  const setConfirmationDialogSettingsRef =
    React.useRef<(current: ConfirmationDialogSettings) => void>();

  const confirm = React.useCallback(
    (title: string, handler: (confirmed: boolean) => void) => {
      if (setConfirmationDialogSettingsRef.current) {
        setConfirmationDialogSettingsRef.current({
          title,
          handler,
        });
      }
    },
    [setConfirmationDialogSettingsRef],
  );

  return {
    setConfirmationDialogSettingsRef,
    confirm,
  };
};
